// re-export the namespaces from vivaa-api, for access to types
import { Client } from 'vivaa-api';
export * from 'vivaa-api';

export const client = new Client();
